import { Scroller, Slider, Video, Image, Overlay, Buttons, PaginationFraction } from '@cian/slider';
import * as React from 'react';

import { Booked } from './components/Booked';
import { CianLayout } from './components/CianLayout';
import { EMediaType, IMedia } from './types';

interface ICarouselProps {
  media: IMedia[];
  deoptimised?: boolean;
  bookedFromCian?: boolean;
  bookedFromDeveloper?: boolean;
  onSlideChange?(): void;
}

export const Carousel: React.FC<ICarouselProps> = ({
  media,
  deoptimised,
  bookedFromCian,
  bookedFromDeveloper,
  onSlideChange,
}) => {
  return (
    <Slider loop onSlideChange={onSlideChange}>
      <Scroller>
        {media.map((m, index) => {
          let slide: React.ReactNode = null;

          switch (m.type) {
            case EMediaType.Layout:
            case EMediaType.Photo:
              slide = (
                <Image
                  key={`slide_${index}`}
                  src={m.src}
                  objectFit={m.type === EMediaType.Layout ? 'contain' : undefined}
                  loading={deoptimised && index === 0 ? null : undefined}
                  decoding={deoptimised && index === 0 ? null : undefined}
                />
              );
              break;
            case EMediaType.Video:
              slide = <Video key={`slide_${index}`} src={m.src} />;
              break;
            case EMediaType.CianLayout:
              slide = <CianLayout key={`slide_${index}`} src={m.src} deoptimised={deoptimised && index === 0} />;
              break;
          }

          if ((bookedFromCian || bookedFromDeveloper) && index === 0) {
            return (
              <Booked key={`slide_${index}`} fromCian={bookedFromCian}>
                {slide}
              </Booked>
            );
          }

          return slide;
        })}
      </Scroller>
      <Overlay>
        <Buttons />
        <PaginationFraction />
      </Overlay>
    </Slider>
  );
};
